import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div>
        {kicker && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-accent-600">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500" />
            {kicker}
          </p>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}